import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  ToastController,
  ModalController,
  LoadingController,
  IonicModule
} from '@ionic/angular';
import AirDatepicker from 'air-datepicker';
import { addDays, max } from 'date-fns';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { Faktura } from 'src/app/services/faktura/faktura.types';
import { SelvbetjeningService } from 'src/app/services/selvbetjening/selvbetjening.service';
import { CustomLocaleNb, theTime } from 'src/app/utils/date-utils';

@Component({
  selector: 'app-utsette-betaling',
  templateUrl: './utsette-betaling.page.html',
  styleUrls: ['./utsette-betaling.page.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class UtsetteBetalingPage implements OnInit, AfterViewInit {
  @Input() faktura: Faktura;
  @Output() dueDateChanged = new EventEmitter<boolean>();

  Datepicker: AirDatepicker<HTMLElement>;
  periodString: string;

  today: Date;
  startDate: Date;
  maxDate: Date;
  minDate: Date;
  selectedDate: Date;
  originalForfall: Date;

  showConfirmation = false;

  constructor(
    private _toast: ToastController,
    public modalCtrl: ModalController,
    private analyticsService: AnalyticsService,
    public loadingController: LoadingController,
    private selvbetjeningService: SelvbetjeningService
  ) { }

  ngOnInit() {
    this.periodString = `${new Date(this.faktura.fradato).toLocaleDateString(
      'nb-NO',
      {
        day: 'numeric',
        month: 'short'
      }
    )} – ${new Date(this.faktura.tildato).toLocaleDateString('nb-NO', {
      day: 'numeric',
      month: 'short'
    })}`;

    // Skal kunne utsette 30 dager fra i dag om man er gått forbi forfallsdato
    this.originalForfall = new Date(this.faktura.forfdato);
    this.today = new Date();
    this.minDate = max([
      addDays(this.today, 1),
      addDays(this.originalForfall, 1)
    ]);
    this.maxDate = max([
      addDays(this.today, 30),
      addDays(this.originalForfall, 30)
    ]);
    this.startDate = max([
      addDays(this.today, 14),
      addDays(this.originalForfall, 14)
    ]);
    this.selectedDate = this.startDate;
  }

  closeThisModal() {
    this.modalCtrl.dismiss();
  }

  ngAfterViewInit() {
    this.Datepicker = new AirDatepicker('#airUtsettelseHour', {
      startDate: this.startDate,
      locale: CustomLocaleNb,
      maxDate: this.maxDate,
      minDate: this.minDate,
      range: false,
      toggleSelected: false,
      view: 'days',
      dateFormat: 'd. MMMM yyyy',
      onSelect: this.selectNewDate.bind(this)
    });
    this.Datepicker.selectDate(this.selectedDate);
  }

  selectNewDate({
    date,
    formattedDate,
    datepicker
  }: {
    date: Date;
    formattedDate: string;
    datepicker: AirDatepicker<HTMLElement>;
  }) {
    if (date && formattedDate) {
      this.selectedDate = date;
    }
  }

  async bekreftUtsettelse() {
    const loading = await this.loadingController.create({
      message: 'Vennligst vent...',
      mode: 'ios'
    });
    await loading.present();

    this.analyticsService.logEvent_selectContent(
      'regninger bekreft betalingsutsettelse'
    );

    const erpId = this.faktura.detaljer?.invoice_id?.toString();
    const dato = theTime(this.selectedDate).toPlainDateString();

    this.selvbetjeningService.updateDueDate(erpId, dato).subscribe({
      next: async () => {
        this.showConfirmation = true;
        loading.dismiss();
        setTimeout(() => {
          this.dueDateChanged.emit(true);
          this.closeThisModal();
        }, 5000);
      },
      error: async (err) => {
        await this._toast
          .create({
            header: 'En feil oppsto',
            message: err?.error?.message,
            duration: 5000,
            position: 'middle',
            color: 'danger'
          })
          .then((toast) => {
            toast.present();
            loading.dismiss();
          });
      }
    });
  }
}
